export default __webpack_public_path__ + "static/media/logo.ed93d10a.png";